import graphql__1d47ba7527448f1a53fb from "./__generated__/MapSidebar_sidebar.graphql.js";
import graphql__6eab712b89e05e6a383a from "./__generated__/MapSidebar_map.graphql.js";import { graphql, useFragment } from "react-relay";

import MapSidebarTitle from "./MapSidebarTitle";
import MapPanelsManager from "./MapPanel/MapPanelsManager";
import MapPanel from "./MapPanel/MapPanel";
import PageSections from "../PageSection/PageSections";

const MapSidebar = ({ keepMapVisibleOnOpen = false, ...props }) => {
  const map = useFragment(MapSidebar_map, props.map);
  const sidebar = useFragment(MapSidebar_sidebar, props.sidebar);
  const { afterTitleChildren = null, children } = props;

  return (
    <MapPanelsManager>
      <MapPanel className="map-sidebar-panel" keepMapVisibleOnOpen={keepMapVisibleOnOpen}>
        <MapSidebarTitle map={map} />

        {afterTitleChildren}

        <PageSections page={sidebar} />

        {children}
      </MapPanel>
    </MapPanelsManager>
  );
};

const MapSidebar_sidebar = graphql__1d47ba7527448f1a53fb;

const MapSidebar_map = graphql__6eab712b89e05e6a383a;

export default MapSidebar;
